import {Button, ButtonGroup, closeCurrentDialog, IconButton} from 'platform/components';
import {Box, Heading, HStack, Show, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

export interface RentalVehicleBlockConflictDialogProps {
  /**
   * Already-translated, server-provided refusal message (e.g. a reservation or active
   * rental conflicting with the requested block period, or a block refusing a
   * reservation). There is no structured detail to render alongside it - the message
   * is the full content of the dialog body.
   */
  message: string;
  /** Optional heading shown next to the close icon. */
  title?: string;
  /** Optional client-side explanation shown above the server message. */
  description?: string;
}

/**
 * @about Single-acknowledge dialog for a refusal caused by a block period conflict: a block
 * create/edit refused by a booking, or a reservation refused by a block.
 * Follows the `SalePresetUpdateInfoDialog` pattern: close icon + body + one confirm button.
 */
export function RentalVehicleBlockConflictDialog(props: RentalVehicleBlockConflictDialogProps) {
  return (
    <>
      <HStack align="center" spacing={4}>
        <Box flex={1}>
          <Show when={props.title}>
            <Heading size={4}>{props.title}</Heading>
          </Show>
        </Box>
        <IconButton
          data-testid="rentalVehicleBlockConflictDialog-close"
          icon="navigation/close"
          onClick={closeCurrentDialog}
        />
      </HStack>
      <VStack spacing={1}>
        <Show when={props.description}>
          <Text>{props.description}</Text>
        </Show>
        <Text>{props.message}</Text>
      </VStack>
      <ButtonGroup align="right">
        <Button
          data-testid="rentalVehicleBlockConflictDialog-confirm"
          variant="primary"
          onClick={closeCurrentDialog}
          title={i18n.t('general.actions.confirm')}
        />
      </ButtonGroup>
    </>
  );
}
